<template>
  <b-card
    v-if="!(isStreetViewMode && isInitial)"
    class="minimize-create-section"
    :class="{ __search: isInitial }"
  >
    <!-- Point Section -->
    <div class="minimize-create-section__header">
      <McButton
        variant="secondary"
        size="sm"
        icon="icon-outline_arrow-left"
        :text="$t('global.back')"
        @click="handleBack"
      />

      <McConfirmation
        v-model="isShowModal"
        centered
        noCloseOnEsc
        noCloseOnBackdrop
        :title="$t('global.confirmation.title')"
        :ok-title="$t('global.confirmation.stayPage')"
        :cancel-title="$t('global.confirmation.exitPage')"
        @handle-ok="isShowModal = false"
        @cancel="handleBack(false)"
      >
        <div>
          <p>{{ $t('global.confirmation.question') }}</p>
          <p>{{ $t('global.confirmation.sure') }}</p>
        </div>
      </McConfirmation>
    </div>

    <PointSection :isInitial="isInitial" />

    <template v-if="!isInitial">
      <template v-if="hasUserGroupFeature">
        <hr />
        <UserGroupSection />
      </template>

      <hr />

      <!-- Vehicle Section -->
      <VehicleSection />
    </template>
  </b-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { redirectLiveview2 } from '@/helpers/navigation-guards'

import McButton from '@/components/McButton'
import McConfirmation from '@/components/McConfirmation'
import PointSection from './PointSection'
import VehicleSection from './VehicleSection'
import UserGroupSection from './UserGroupSection'

export default {
  components: {
    McButton,
    McConfirmation,
    PointSection,
    VehicleSection,
    UserGroupSection,
  },
  mixins: [Helper],
  data() {
    return {
      isShowModal: false,
    }
  },
  computed: {
    ...mapState('fleetTaskInstant', ['selectedPoints', 'isStreetViewMode']),
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasUserGroupFeature() {
      const hasScope = this.hasAccessAll(['tms-user-group:read'])
      const isSuperUser = this.isSuperUser()

      return hasScope && isSuperUser
    },
    isInitial() {
      if (this.selectedPoints.length > 1) {
        return false
      }

      if (this.selectedPoints[0].id) {
        return false
      }

      return true
    },
  },
  methods: {
    async handleBack(isNeedConfirm = true) {
      if (!this.isInitial && isNeedConfirm) {
        this.isShowModal = true
        return
      }

      this.isShowModal = false

      let params = {}
      const query = { ...this.$route.query }
      const routeName = this.$route.query?.navsource || 'Fleet Task'

      // redirect to Liveview 2
      if (routeName === 'Liveview 2') {
        redirectLiveview2()

        return
      } else if (routeName === 'Fleet Task') {
        query.type = 'instant'
      }

      if (query.navsourceparam) {
        params = JSON.parse(query.navsourceparam)
      }

      delete query.navsource
      delete query.navsourceparam

      this.$router.push({ name: routeName, params, query })
    },
  },
}
</script>

<style lang="scss" scoped>
.minimize-create-section {
  min-width: 35%;
  height: calc(100vh - 118px - 15px);
  border: 1px solid $mep-primary-100;
  overflow-y: auto;

  &__header {
    margin: 16px;
  }

  .card-body {
    padding: 0;
    display: grid;
    grid-template-rows: auto 1fr auto 1fr;
    max-height: 100%;
  }

  &.__search {
    position: absolute;
    z-index: 2;
    top: 20px;
    left: 20px;
    width: 440px;
    height: fit-content;

    .card-body {
      display: block;
    }
  }
}
</style>
